<template>
  <div v-bind="$attrs">

    <v-label
      v-if="label"
      :editable="editableLabel"
      :text="label"
      @update="$emit('update:label', $event)">
    </v-label>

    <label
      class="checkbox"
      v-for="option in options"
      :key="option">
      <input
        type="checkbox"
        :disabled="disabled"
        :checked="value.indexOf(option) != -1"
        @input="toggle(option)">
      <span v-html="option"></span>
    </label>

  </div>
</template>

<script>
import VLabel from '@/components/base/VLabel'

export default {
  props: {
    value: {
      type: Array
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: [String, Number],
      default: null
    },
    editableLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VLabel
  },
  methods: {
    toggle(option) {
      const index = this.value.indexOf(option);
      let valueCopy = [...this.value];
      if (index == -1) {
        valueCopy.push(option);
        this.$emit('input', valueCopy);
      } else {
        valueCopy.splice(index, 1);
        this.$emit('input', valueCopy);
      }
    }
  }
}
</script>

<style scoped>
.checkbox:not(:last-child) {
  margin-right: 1em;
}

.checkbox span {
  margin-left: 0.3em;
}
</style>
